module.exports = __webpack_public_path__ + "static/img/banner-shop-mobile.4ee120a3.png";